import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../../hooks/useAuth';

const HeroSection = () => {
  const navigate = useNavigate();
  const { userId, isAuth, logout } = useAuth();

  return (
    <section className="relative min-h-screen flex items-center justify-center overflow-hidden">
      {/* Background Image */}
      <div
        className="absolute inset-0 bg-cover bg-center bg-no-repeat"
        style={{
          backgroundImage: `url('https://readdy.ai/api/search-image?query=Cute%20colorful%203D%20avatar%20characters%20teaching%20live%20online%20classes%20in%20a%20bright%20cheerful%20virtual%20classroom%20setting%20with%20holographic%20screens%20floating%20books%20digital%20whiteboards%20and%20interactive%20learning%20elements%20adorable%20animal-like%20teacher%20avatars%20with%20friendly%20expressions%20conducting%20engaging%20lessons%20for%20children%20modern%20educational%20technology%20background%20with%20soft%20pastel%20colors%20and%20playful%20atmosphere&width=1920&height=1080&seq=hero-avatar-bg-001&orientation=landscape')`
        }}
      >
        <div className="absolute inset-0 bg-gradient-to-r from-blue-900/80 to-purple-900/60"></div>
      </div>

      {/* Navigation */}
      <nav className="absolute top-0 left-0 right-0 z-20 md:py-6 md:px-4 py-2 px-2">
        <div className="max-w-7xl mx-auto flex items-center justify-between">
          <div className="flex items-center space-x-2">
            <div className="md:w-10 md:h-10 w-8 h-8 bg-gradient-to-r from-blue-500 to-purple-600 rounded-lg flex items-center justify-center">
              <span className="text-white font-bold md:text-xl text-md">
                AI
              </span>
            </div>
            <span className="text-white font-bold text-sm md:text-xl whitespace-nowrap">
              AIKnow 라이브 클래스
            </span>
          </div>

          <div className="hidden md:flex items-center space-x-8">
            <a
              href="#features"
              className="text-white hover:text-blue-200 transition-colors"
            >
              수업 소개
            </a>
            <a
              href="#classes"
              className="text-white hover:text-blue-200 transition-colors"
            >
              인기 수업
            </a>
            <a
              href="#teachers"
              className="text-white hover:text-blue-200 transition-colors"
            >
              선생님
            </a>
            <a
              href="#contact"
              className="text-white hover:text-blue-200 transition-colors"
            >
              문의하기
            </a>
          </div>

          <div className="hidden md:flex items-center space-x-2 md:space-x-4">
            {isAuth && (
              <button
                onClick={() => navigate('/member/mypage')}
                className="text-white text-m px-3 py-2 rounded-full bg-white/10 border border-white/20 backdrop-blur-md whitespace-nowrap"
              >
                {userId}님
              </button>
            )}
            <button
              onClick={isAuth ? logout : () => navigate('/member/login')}
              className="text-white text-m px-3 py-2 rounded-full bg-white/10 border border-white/20 backdrop-blur-md whitespace-nowrap"
            >
              {isAuth ? '로그아웃' : '로그인'}
            </button>
            <a
              href="https://www.youtube.com/shorts/H6j-cortw3E"
              target="_blank"
              className="md:text-lg text-xs bg-gradient-to-r from-blue-500 to-purple-600 text-white md:px-6 px-2 py-2 rounded-full hover:from-blue-600 hover:to-purple-700 transition-all whitespace-nowrap"
            >
              AI시대 자녀 교육
            </a>
          </div>
        </div>
      </nav>

      <div className="absolute top-12 left-0 z-20 px-2 flex md:hidden items-center justify-end gap-2">
        {isAuth && (
          <button
            onClick={() => navigate('/member/mypage')}
            className="text-white text-xs px-3 py-2 rounded-full bg-white/10 border border-white/20 backdrop-blur-md whitespace-nowrap"
          >
            {userId}님
          </button>
        )}
        <button
          onClick={isAuth ? logout : () => navigate('/member/login')}
          className="text-white text-xs px-3 py-2 rounded-full bg-white/10 border border-white/20 backdrop-blur-md whitespace-nowrap"
        >
          {isAuth ? '로그아웃' : '로그인'}
        </button>
        <a
          href="https://www.youtube.com/shorts/H6j-cortw3E"
          target="_blank"
          className="md:text-lg text-xs bg-gradient-to-r from-blue-500 to-purple-600 text-white md:px-6 px-2 py-2 rounded-full hover:from-blue-600 hover:to-purple-700 transition-all whitespace-nowrap"
        >
          AI시대 자녀 교육
        </a>
      </div>

      {/* Hero Content */}
      <div className="relative z-10 max-w-7xl mx-auto px-4 text-center text-white pt-4 md:pt-0">
        <div className="max-w-4xl mx-auto">
          <h1 className="text-2xl md:text-5xl font-bold mb-6 leading-tight">
            <span className="block">AI 아바타 선생님과 함께하는</span>
            <span className="block bg-gradient-to-r from-blue-400 to-purple-400 bg-clip-text text-transparent">
              라이브 클래스
            </span>
          </h1>

          <p className="text-sm md:text-2xl md:mb-8 mb-6 text-gray-200 leading-relaxed tracking-tight">
            초등학생을 위한 개인 맞춤형 AI 라이브 교육으로
            <br />
            재미있게 배우고 실력을 키워보세요
          </p>

          <div className="flex flex-col sm:flex-row items-center justify-center space-y-4 sm:space-y-0 sm:space-x-6 md:mb-12 mb-6">
            <a
              href="#"
              onClick={(e) => {
                e.preventDefault();
                if (isAuth) {
                  navigate('/passport');
                } else {
                  alert('로그인 후 이용해주세요');
                  navigate('/member/login');
                }
              }}
              rel="noopener noreferrer"
              className="bg-gradient-to-r from-blue-500 to-purple-600 text-white md:px-8 px-4 md:py-4 py-3 rounded-full md:text-lg text-md font-bold hover:from-blue-600 hover:to-purple-700 transition-all transform hover:scale-105 whitespace-nowrap"
            >
              <i className="ri-play-circle-line mr-2"></i>내 AI탐험여권 보기
            </a>
            <a
              href="https://docs.google.com/forms/d/1230wmKLovQYswp_4mYqcKbkkyRoMjGzJYsvBZfg9uAg/edit"
              target="_blank"
              rel="noopener noreferrer"
              className="border-2 border-white text-white md:px-8 px-4 md:py-4 py-3 rounded-full md:text-lg text-md font-bold hover:bg-white hover:text-purple-600 transition-all whitespace-nowrap"
            >
              <i className="ri-video-line mr-2"></i>내 AI작품 뽐내기
            </a>
          </div>

          {/* Stats */}
          <div className="grid grid-cols-1 md:grid-cols-3 md:gap-8 gap-4 md:mt-16 mt-6">
            <div className="text-center">
              <div className="md:text-4xl text-3xl font-bold text-blue-400 mb-2">
                10,000+
              </div>
              <div className="text-gray-300">수강생</div>
            </div>
            <div className="text-center">
              <div className="md:text-4xl text-3xl font-bold text-purple-400 mb-2">
                500+
              </div>
              <div className="text-gray-300">AI 수업</div>
            </div>
            <div className="text-center">
              <div className="md:text-4xl text-3xl font-bold text-pink-400 mb-2">
                98%
              </div>
              <div className="text-gray-300">만족도</div>
            </div>
          </div>
        </div>
      </div>

      {/* Scroll Indicator */}
      <div className="absolute bottom-4 left-1/2 transform -translate-x-1/2">
        <div className="animate-bounce">
          <i className="ri-arrow-down-line text-white text-2xl"></i>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
